import { Icon } from "@/components";
import { cn } from "@/utils";

interface TokenProps {
  symbol?: string;
  logoURI?: string;
  alt?: string;
  className?: string;
  showUnverified?: boolean;
}

export const TokenIcon = ({
  showUnverified,
  logoURI,
  alt,
  className,
}: TokenProps) => {
  return (
    <div className={cn("relative w-fit", className)}>
      {logoURI ? (
        <img
          src={logoURI}
          alt={alt || ""}
          className={cn("rounded-full bg-cloud")}
          // // eslint-disable-next-line @typescript-eslint/no-explicit-any
          // onError={(event: any) => {
          //   // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          //   event.target.src = "/unknown-token.svg";
          //   // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          //   event.onerror = null;
          // }}
        />
      ) : (
        <Icon name="unknown" />
      )}
      {showUnverified ? (
        <Icon
          name="warning"
          className="w-5 h-5 text-accent absolute right-0 bottom-0"
        />
      ) : null}
    </div>
  );
};
